import React, { useRef } from "react";

export default function accessibleTabs(WrappedComponent) {
  return function EnhancedComponent({
    tabs,
    handleTab,
    selectedTab,
    selectedIndex,
  }) {
    const tabRefs = useRef([]);

    const handleKeyDown = ({ e, index, tab, ...rest }) => {
      let nextIndex = index;

      switch (e.key) {
        case "ArrowRight":
          nextIndex = (index + 1) % tabs.length;
          tabRefs.current[nextIndex]?.focus();
          break;

        case "ArrowLeft":
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          tabRefs.current[nextIndex]?.focus();
          break;

        case "Home":
          tabRefs.current[0]?.focus();
          break;

        case "End":
          tabRefs.current[tabs.length - 1]?.focus();
          break;

        case "Enter":
        case " ":
          e.preventDefault();
          handleTab({ tab, index, ...rest });
          break;

        default:
          break;
      }
    };

    return (
      <WrappedComponent
        tabs={tabs}
        selectedTab={selectedTab}
        selectedIndex={selectedIndex}
        handleTab={(props) => handleTab(props)}
        handleKeyDown={(props) => handleKeyDown(props)}
        ref={tabRefs}
      />
    );
  };
}
